import removeItemLocalStorageUtil from 'utils/local-storage/remove-item'
import { LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY } from 'containers/LoyaltyFastTrackExpiry/constants'

export default function removeLocalStorageKeysLoyaltyFastTrackUtil (isModal = true) {
  removeItemLocalStorageUtil(LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY.MODAL_CLOSED_AT)
  removeItemLocalStorageUtil(LOYALTY_FAST_TRACK_EXPIRY_LOCAL_STORAGE_KEY.BANNER_CLOSED_AT)
}
